import { render, staticRenderFns } from "./ModalWaiting.vue?vue&type=template&id=c33183e2&scoped=true"
import script from "./ModalWaiting.vue?vue&type=script&lang=js"
export * from "./ModalWaiting.vue?vue&type=script&lang=js"
import style0 from "./ModalWaiting.vue?vue&type=style&index=0&id=c33183e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c33183e2",
  null
  
)

export default component.exports